import * as Action from './action';

const defineInitialState = () => ({
  jobs: [],
});

const pushJob = (item, jobs) => {
  let results = jobs;

  if (jobs?.length > 0) {
    results.push(item);
  } else {
    results[0] = item;
  }

  return results;
};

const deleteJob = (jobs, index) => {
  let i = jobs.indexOf(index);

  if (i > -1) {
    jobs.splice(i, 1);
  }

  return jobs;
};

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$addJob.ACTION:
      const j = pushJob(action?.item, state?.jobs);
      return {
        ...state,
        jobs: j,
      };
    case Action.$deleteJob.ACTION:
      const i = deleteJob(state?.jobs, action?.index);
      return {
        ...state,
        jobs: i,
      };
    default:
      return state;
  }
}

export function persister({ jobs }) {
  return {
    jobs,
  };
}
